import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, NavLink } from 'react-router-dom';
import AdmissionForm from '../Form';
import SearchEnroll from '../SearchEnroll';
import EnquiryStatus from '../EnquiryStatus';
import AllCenterCourses from '../../AllCenterCourses';
import Remainders from '../Remainders';
import Dashboard from '../Dashboard';

const AdmissionSidebar = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [userName, setUserName] = useState('');

  useEffect(() => {
    const jwtToken = localStorage.getItem("jwt_token");
    const name = localStorage.getItem("name");

    if (!jwtToken) {
      navigate("/");
    }

    if (name) {
      setUserName(name);
    }
  }, [navigate]);

  const logOut = () => {
    localStorage.removeItem("jwt_token");
    localStorage.removeItem("center");
    localStorage.removeItem("name");
    navigate("/");
  };

  return (
    <div className="container-fluid" style={{ height: "100vh" }}>
      <div className="row flex-nowrap">
        <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0 bg-dark" style={{ height: "100vh" }}>
          <div className="d-flex flex-column align-items-center align-items-sm-start px-3 pt-2 text-white min-vh-100">
            <div className="d-flex flex-column pb-3 mb-md-0 me-md-auto text-white text-decoration-none">
              <span className="fs-5 d-none d-sm-inline">Datapro<br />Computers</span>
              <span className="text-light mt-2">
                <strong>Welcome,</strong> {userName}
              </span>
            </div>

            <ul className="nav nav-pills flex-column mb-sm-auto mb-0 align-items-center align-items-sm-start" id="menu">
              <li className="nav-item">
                <NavLink to="/admission-process/dashboard" className={({ isActive }) => `nav-link align-middle px-0 sidebar-link${isActive ? ' active' : ''}`}>
                  <i className="fs-4 bi-house"></i> <span className="ms-1 d-none d-sm-inline">Dashboard</span>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/admission-process/form" className={({ isActive }) => `nav-link align-middle px-0 sidebar-link${isActive ? ' active' : ''}`}>
                  <i className="fs-4 bi-plus-square"></i> <span className="ms-1 d-none d-sm-inline">New Admission</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/admission-process/search-enroll" className={({ isActive }) => `nav-link px-0 align-middle sidebar-link${isActive ? ' active' : ''}`}>
                  <i className="fs-4 bi-search"></i> <span className="ms-1 d-none d-sm-inline">Search & Enroll</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/admission-process/enquiry-status" className={({ isActive }) => `nav-link px-0 align-middle sidebar-link${isActive ? ' active' : ''}`}>
                  <i className="fs-4 bi-question-circle"></i> <span className="ms-1 d-none d-sm-inline">Enquiry Status</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/admission-process/courses" className={({ isActive }) => `nav-link px-0 align-middle sidebar-link${isActive ? ' active' : ''}`}>
                  <i className="fs-4 bi-journal-bookmark"></i> <span className="ms-1 d-none d-sm-inline">Courses</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/admission-process/remainders" className={({ isActive }) => `nav-link px-0 align-middle sidebar-link${isActive ? ' active' : ''}`}>
                  <i className="fs-4 bi-clock-history"></i> <span className="ms-1 d-none d-sm-inline">Remainders</span>
                </NavLink>
              </li>
            </ul>

            <hr />
            <div className="dropdown pb-4">
              <button onClick={logOut} className="btn btn-outline-light btn-sm">Logout</button>
            </div>
          </div>
        </div>

        <div className="col py-3" style={{ height: "100vh", overflow: "auto" }}>
          {id === 'dashboard' && <Dashboard />}
          {id === 'form' && <AdmissionForm />}
          {id === 'search-enroll' && <SearchEnroll />}
          {id === "enquiry-status" && <EnquiryStatus />}
          {id === 'courses' && <AllCenterCourses />}
          {id === 'remainders' && <Remainders />}
        </div>
      </div>
    </div>
  );
};

export default AdmissionSidebar;
